"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function ClockIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("path", { d: "m12,23.193C5.828,23.193.807,18.172.807,12S5.828.807,12,.807s11.193,5.021,11.193,11.193-5.021,11.193-11.193,11.193Zm0-20.687C6.766,2.507,2.507,6.765,2.507,12s4.259,9.493,9.493,9.493,9.493-4.259,9.493-9.493S17.234,2.507,12,2.507Z" }),
        react_1.default.createElement("path", { d: "m15.77,17.633l-4.375-4.375c-.159-.16-.249-.375-.249-.601v-7.716h1.7v7.364l4.126,4.126-1.202,1.202Z" })));
}
exports.default = ClockIcon;
